export const ABI = require('../../contracts/src/contracts/test/VeFree.json').abi
